// Canonical public URL for outgoing links (social share, SEO og:url, referrals).
// Uses REACT_APP_PUBLIC_URL (e.g. https://balmarts.com) regardless of where
// the app is currently hosted (preview/staging), so shared links ALWAYS point
// to the real production domain.
const PUBLIC_BASE = (process.env.REACT_APP_PUBLIC_URL || '').replace(/\/$/, '');

export function publicUrl(path = '') {
  if (!PUBLIC_BASE) {
    // Fallback to current origin if not configured
    return typeof window !== 'undefined' ? window.location.origin + path : path;
  }
  if (!path) return PUBLIC_BASE;
  return `${PUBLIC_BASE}${path.startsWith('/') ? '' : '/'}${path}`;
}

export function publicCurrentUrl() {
  // Build the public equivalent of window.location.pathname + search
  if (typeof window === 'undefined') return PUBLIC_BASE;
  return publicUrl(window.location.pathname + window.location.search);
}
